import Button from '@/components/ui/buttons/Button';
import Modal from '@/components/ui/modals/Modal';
import { type ModalInnerProps } from '@/hooks/common/useModal';

import styles from './AbsencesEditedModal.module.scss';

type Props = ModalInnerProps;

const AbsencesEditedModal: React.FC<Props> = ({ isOpen, toggle }) => (
  <Modal isOpen={isOpen} toggle={toggle} title={'欠席連絡の編集が完了しました'}>
    <div className={styles.description}>
      欠席連絡の編集が正常に送信完了しました。
      <br />
      別途、お電話等での確認は不要です。
    </div>
    <div className={styles.buttons}>
      <Button
        size="s"
        color="outline"
        onClick={toggle}
        className={styles.button}
      >
        閉じる
      </Button>
    </div>
  </Modal>
);

export default AbsencesEditedModal;
